<template>
  <div class="widget__content-center widget__content-center--flex">
    <div class="widget__header-text">Showing Zone <span>Total Dwell Time</span> across Event</div>

    <WidgetTime :time="widgetTime" />

    <div class="dwell__time-text">
      At <span class="widget-message__yellow">{{ zone?.title }}</span> Zone
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import WidgetTime from '../WidgetTime.vue';
import type { WidgetSetting, WidgetTypeEngagedVisitDwell } from '@/types/Widget';

const props = defineProps<{
  zone?: WidgetSetting;
  widget: WidgetTypeEngagedVisitDwell;
}>();

const widgetTime = computed(() => {
  const zoneId = props.zone?.id;

  if (zoneId) {
    const dwellTime = props.widget.data['Zone'][zoneId]['Total'] as any;
    return dwellTime;
  }
  return 0;
});
</script>
